import { combineReducers } from 'redux';
import userReducer from './userReducer';
import loadingReducer from './loadingReducer';
import offeringReducer from './offeringReducer';
import { reducer as formReducer } from 'redux-form';
import forgotPasswordReducer from './forgotPasswordReducer';
import changePasswordReducer from './changePasswordReducer';
import resetPasswordReducer from './resetPasswordReducer';
import offeringDetailReducer from './offeringDetailReducer';
import offeringUserInfoReducer from './offeringUserInfoReducer';

export default combineReducers({
  form: formReducer,
  user: userReducer,
  isLoading: loadingReducer,
  offering: offeringReducer,
  forgotPassword: forgotPasswordReducer,
  changePassword: changePasswordReducer,
  resetPassword: resetPasswordReducer,
  offeringDetail: offeringDetailReducer,
  offeringUserInfo: offeringUserInfoReducer,
});